import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { changePassword } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function AdminAccount() {
  const { user, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("New password must be at least 8 characters.");
      return;
    }
    if (next !== confirm) {
      toast.error("Passwords don't match.");
      return;
    }
    setBusy(true);
    try {
      await changePassword(current, next);
      toast.success("Password updated. Please sign in again.");
      setTimeout(() => logout(), 500);
    } catch (err) {
      const detail = err?.response?.data?.detail || "Couldn't change password.";
      toast.error(typeof detail === "string" ? detail : "Couldn't change password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="px-6 lg:px-10 py-10 max-w-2xl">
      <div className="text-[10px] tracking-[0.32em] uppercase text-[#4A6D8C] mb-2">
        Account
      </div>
      <h1 className="font-display text-4xl tracking-tight">Settings</h1>

      <div className="mt-8 bg-[#0f0f0f] border border-[#1a1a1a] p-6">
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#737373]">Signed in as</div>
        <div className="text-[15px] mt-1">{user?.email}</div>
      </div>

      <form onSubmit={submit} data-testid="change-password-form" className="mt-8 bg-[#0f0f0f] border border-[#1a1a1a] p-6">
        <div className="flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-[#A3A3A3] mb-4">
          <KeyRound size={12} /> Change password
        </div>
        <label className="text-[10px] tracking-[0.28em] uppercase text-[#737373]">Current password</label>
        <input
          type="password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          className="hl-input"
          data-testid="cp-current"
          autoComplete="current-password"
        />
        <label className="text-[10px] tracking-[0.28em] uppercase text-[#737373] mt-4 block">New password</label>
        <input
          type="password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
          className="hl-input"
          data-testid="cp-new"
          autoComplete="new-password"
        />
        <label className="text-[10px] tracking-[0.28em] uppercase text-[#737373] mt-4 block">Confirm new password</label>
        <input
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="hl-input"
          data-testid="cp-confirm"
          autoComplete="new-password"
        />
        <button
          type="submit"
          disabled={busy}
          data-testid="cp-submit"
          className="hl-btn-primary mt-8 disabled:opacity-60"
        >
          {busy ? "Updating…" : "Update password"}
        </button>
      </form>
    </div>
  );
}
